declare global {
  interface Window {
    _qha: {
      (...args: unknown[]): void;
      c?: unknown[];
      s?: boolean;
    };
  }
}

export const loadSo360Tracking = (siteId = 629201) => {
  if (document.querySelector(`script[data-so360-qha="${siteId}"]`)) {
    return;
  }

  const win = window as Window;
  win._qha = win._qha || ((...args: unknown[]) => {
    (win._qha.c = win._qha.c || []).push(args);
  });
  win._qha.s = false;

  const script = document.createElement('script');
  script.setAttribute('data-so360-qha', String(siteId));
  script.src = `//s.union.360.cn/${siteId}.js`;
  script.defer = true;
  script.async = true;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
};
